import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";

const KEY_OF_ACADEMIC_YEAR = "systemAcademicYear";

const fetchCurrentAcademicYear = async (): Promise<ApiResponse<number>> => {
  return await httpClient.get(`/apis/configuration/${KEY_OF_ACADEMIC_YEAR}`);
};
const fetchServerTime = async (): Promise<ApiResponse<number>> => {
  return await httpClient.get("/apis/configuration/serverTime");
};
export default {
  fetchCurrentAcademicYear,
  fetchServerTime,
};
